import { render, staticRenderFns } from "./reporte-saldos.vue?vue&type=template&id=74fddcdc&scoped=true"
import script from "./reporte-saldos.vue?vue&type=script&lang=js"
export * from "./reporte-saldos.vue?vue&type=script&lang=js"
import style0 from "./reporte-saldos.vue?vue&type=style&index=0&id=74fddcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fddcdc",
  null
  
)

export default component.exports